export const Legends = {
  FULFILLED_SYSTEM_PROCESSED_FORMATIONCONTINUE: {
    label: 'FULFILLED_SYSTEM_PROCESSED_FORMATIONCONTINUE',
    class: 'FULFILLED_SYSTEM_PROCESSED_FORMATIONCONTINUE',
    display: false
  },
  INCOHERENCE_VALIDATED_FORMATIONCONTINUE: {
    label: 'INCOHERENCE_VALIDATED_FORMATIONCONTINUE',
    class: 'INCOHERENCE_VALIDATED_FORMATIONCONTINUE',
    display: true
  },
  FULFILLED_VALIDATED_FORMATIONCONTINUE: {
    label: 'FULFILLED_VALIDATED_FORMATIONCONTINUE',
    class: 'FULFILLED_VALIDATED_FORMATIONCONTINUE',
    display: true
  },
  FULFILLED_VALIDATED_FORMATIONCONTINUE_BYUSER: {
    label: "FULFILLED_VALIDATED_FORMATIONCONTINUE_BYUSER",
    class: "FULFILLED_VALIDATED_FORMATIONCONTINUE_BYUSER",
    display: true
  },
  FULFILLED_SYSTEM_PROCESSED_CONTROLEQUALITE: {
    label: 'FULFILLED_SYSTEM_PROCESSED_CONTROLEQUALITE',
    class: 'FULFILLED_SYSTEM_PROCESSED_CONTROLEQUALITE',
    display: false
  },
  INCOHERENCE_VALIDATED_CONTROLEQUALITE: {
    label: 'INCOHERENCE_VALIDATED_CONTROLEQUALITE',
    class: 'INCOHERENCE_VALIDATED_CONTROLEQUALITE',
    display: false
  },
  FULFILLED_VALIDATED_CONTROLEQUALITE: {
    label: 'FULFILLED_VALIDATED_CONTROLEQUALITE',
    class: 'FULFILLED_VALIDATED_CONTROLEQUALITE',
    display: true
  },
  FULFILLED_VALIDATED_CONTROLEQUALITE_BYUSER: {
    label: 'FULFILLED_VALIDATED_CONTROLEQUALITE',
    class: 'FULFILLED_VALIDATED_CONTROLEQUALITE',
    display: true
  },
  FORMATION_ALTERNANCE_INSERVICE: {
    label: 'FORMATION_ALTERNANCE_INSERVICE',
    class: 'FORMATION_ALTERNANCE_INSERVICE',
    display: true
  },
  FORMATION_INSERVICE: {
    label: 'FORMATION_INSERVICE',
    class: 'FORMATION_INSERVICE',
    display: true
  },
  FORMATION_OFFSERVICE: {
    label: 'FORMATION_OFFSERVICE',
    class: 'REPAS_OFFSERVICE',
    display: true
  },
  PAIDHOLIDAY_OFFSERVICE: {
    label: 'PAIDHOLIDAY_OFFSERVICE',
    class: 'PAIDHOLIDAY_OFFSERVICE',
    display: true
  },
  SENIORITYHOLIDAY_OFFSERVICE: {
    label: 'SENIORITYHOLIDAY_OFFSERVICE',
    class: 'SENIORITYHOLIDAY_OFFSERVICE',
    display: true
  },
  UNPAIDHOLIDAY_OFFSERVICE: {
    label: 'UNPAIDHOLIDAY_OFFSERVICE',
    class: 'UNPAIDHOLIDAY_OFFSERVICE',
    display: true
  },
  RTTHOLIDAY_OFFSERVICE: {
    label: 'RTTHOLIDAY_OFFSERVICE',
    class: 'RTTHOLIDAY_OFFSERVICE',
    display: true
  },
  CASUALLEAVE_OFFSERVICE: {
    label: 'CASUALLEAVE_OFFSERVICE',
    class: 'CASUALLEAVE_OFFSERVICE',
    display: true
  },
  PAUSE_INSERVICE: {
    label: 'PAUSE_INSERVICE',
    class: 'PAUSE_INSERVICE',
    display: true
  },
  FULLFILLED_PAUSE: {
    label: 'FULLFILLED_PAUSE',
    class: 'FULLFILLED_PAUSE',
    display: true
  },
  ACTION_INSERVICE: {
    label: 'ACTION_INSERVICE',
    class: 'ACTION_INSERVICE',
    display: true
  },
  REPAS_OFFSERVICE: {
    label: 'REPAS_OFFSERVICE',
    class: 'REPAS_OFFSERVICE',
    display: true
  },
  BRIEF_INSERVICE: {
    label: 'BRIEF_INSERVICE',
    class: 'BRIEF_INSERVICE',
    display: true
  },
  FORMATION_MUTUALISATION_INSERVICE: {
    label: 'FORMATION_MUTUALISATION_INSERVICE',
    class: 'FORMATION_MUTUALISATION_INSERVICE',
    display: true
  },
  FORMATION_CONTINUE_INSERVICE: {
    label: 'FORMATION_CONTINUE_INSERVICE',
    class: 'FORMATION_CONTINUE_INSERVICE',
    display: true
  },
  CONTROLE_QUALITE_INSERVICE: {
    label: 'CONTROLE_QUALITE_INSERVICE',
    class: 'CONTROLE_QUALITE_INSERVICE',
    display: true
  },
  INCOHERENCE_VALIDATED_FORMATIONCONTINUE_BYUSER: {
    label: 'FORMATION_CONTINUE_INSERVICE',
    class: 'INCOHERENCE_VALIDATED_FORMATIONCONTINUE_BYUSER',
    display: true
  },
  INCOHERENCE_VALIDATED_CONTROLEQUALITE_BYUSER: {
    label: 'CONTROLE_QUALITE_INSERVICE',
    class: 'INCOHERENCE_VALIDATED_CONTROLEQUALITE_BYUSER',
    display: false
  },
  INACTIF_OFFSERVICE: {
    label: 'INACTIF_OFFSERVICE',
    class: 'INACTIF_OFFSERVICE',
    display: true
  },
  IRP_INSERVICE: {
    label: 'IRP_INSERVICE',
    class: 'IRP_INSERVICE',
    display: true
  },
  HORS_PRODUCTION_OFFSERVICE: {
    label: 'HORS_PRODUCTION_OFFSERVICE',
    class: 'HORS_PRODUCTION_OFFSERVICE',
    display: true
  },
  PRÉAVIS_OFFSERVICE: {
    label: 'PRÉAVIS_OFFSERVICE',
    class: 'PRÉAVIS_OFFSERVICE',
    display: true
  },
  ALLAITEMENT_OFFSERVICE: {
    label: 'ALLAITEMENT_OFFSERVICE',
    class: 'ALLAITEMENT_OFFSERVICE',
    display: true
  },
  EXCEPTIONALHOLIDAY_OFFSERVICE: {
    label: 'EXCEPTIONALHOLIDAY_OFFSERVICE',
    class: 'EXCEPTIONALHOLIDAY_OFFSERVICE',
    display: true
  },
  ALIVE_INSERVICE: {
    label: 'ALIVE_INSERVICE',
    class: 'ALIVE_INSERVICE',
    display: true
  },
  INCOHERENCE: {
    label: 'INCOHERENCE',
    class: 'break',
    display: false
  },
  INSERVICE: {
    label: 'INSERVICE',
    class: 'inservice',
    display: true
  },
  FULFILLED_VALIDATED_INSERVICE_TAD: {
    label: 'FULFILLED_VALIDATED_INSERVICE_TAD',
    class: 'FULFILLED_VALIDATED_INSERVICE_TAD',
    display: true
  },
  OFFSERVICE: {
    label: 'OFFSERVICE',
    class: 'horsservice',
    display: true
  },
  FULFILLED: {
    label: 'FULFILLED',
    class: 'inservice',
    display: true
  },
  NULL: {
    label: 'NULL',
    class: 'incoherences',
    display: true
  },
  EMPTY: {
    label: 'EMPTY',
    class: 'nodata',
    display: false
  },
  DAYOFF: {
    label: 'DAYOFF',
    class: 'dayoff',
    display: true
  },
  OFF_OFFSERVICE: {
    label: 'DAYOFF',
    class: 'dayoff-block',
    display: true
  },
  MISE_A_PIED: {
    label: 'MISE_A_PIED',
    class: 'mise-a-pied',
    display: true
  },
  UNKNOWN: {
    label: 'UNKNOWN',
    class: 'unknown',
    display: false
  },
  FULFILLED_SYSTEM_PROCESSED_INSERVICE: {
    label: 'FULFILLED_SYSTEM_PROCESSED_INSERVICE',
    class: 'ACTION_INSERVICE',
    display: false
  },
  FULFILLED_VALIDATED_INSERVICE: {
    label: 'FULFILLED_VALIDATED_INSERVICE',
    class: 'inservice',
    display: false
  },
  FULFILLED_VALIDATED_INSERVICE_BYUSER: {
    label: 'FULFILLED_VALIDATED_INSERVICE_BYUSER',
    class: 'inservice',
    display: false
  },
  FULFILLED_VALIDATED_OFFSERVICE: {
    label: 'FULFILLED_VALIDATED_OFFSERVICE',
    class: 'horsservice',
    display: false
  },
  INCOHERENCE_CREATED_OFFSERVICE: {
    label: 'INCOHERENCE_CREATED_OFFSERVICE',
    class: 'INCOHERENCE_OFF',
    display: true
  },
  INCOHERENCE_CREATED_INSERVICE: {
    label: 'INCOHERENCE_CREATED_INSERVICE',
    class: 'INCOHERENCE_ON',
    display: true
  },
  INCOHERENCE_VALIDATED_OFFSERVICE: {
    label: 'INCOHERENCE_VALIDATED_OFFSERVICE',
    class: 'INCOHERENCE_OFF',
    display: true
  },
  INCOHERENCE_VALIDATED_INSERVICE: {
    label: 'INCOHERENCE_VALIDATED_INSERVICE',
    class: 'INCOHERENCE_ON',
    display: true
  },

  NOWORKINGPUBLICHOLIDAY_OFFSERVICE: {
    label: 'NOWORKINGPUBLICHOLIDAY_OFFSERVICE',
    class: 'NOWORKINGPUBLICHOLIDAY_OFFSERVICE',
    display: true
  },
  INCOHERENCE_CREATED_OFFSERVICE_BYUSER: {
    label: 'INCOHERENCE_CREATED_OFFSERVICE_BYUSER',
    class: 'INCOHERENCE_OFF_BYUSER',
    display: true
  },
  INCOHERENCE_CREATED_INSERVICE_BYUSER: {
    label: 'INCOHERENCE_CREATED_INSERVICE_BYUSER',
    class: 'INCOHERENCE_ON_BYUSER',
    display: true
  },
  INCOHERENCE_VALIDATED_OFFSERVICE_BYUSER: {
    label: 'INCOHERENCE_VALIDATED_OFFSERVICE_BYUSER',
    class: 'INCOHERENCE_OFF_BYUSER',
    display: true
  },
  INCOHERENCE_VALIDATED_INSERVICE_BYUSER: {
    label: 'INCOHERENCE_VALIDATED_INSERVICE_BYUSER',
    class: 'INCOHERENCE_ON_BYUSER',
    display: true
  },
  CONGE_INCOHERENCE: {
    label: 'CONGE_INCOHERENCE',
    class: 'CONGE_INCOHERENCE',
    display: true
  },
};



// WEBPACK FOOTER //
// ./src/app/model/Legends.ts